<template lang="pug">
  .modal.is-active
    .modal-background(@click="cerrarModal")
    .modal-content
      .box
        span.title(v-html="getTipoResp(responsiva)")
        a.button.is-warning.is-small.is-rounded(@click="editarResponsiva(responsiva)" v-show="verBotones")
          i.fas.fa-pencil-alt
        | &nbsp
        a.button.is-danger.is-small.is-rounded(@click="borrarResponsiva(responsiva)" v-show="verBotones")
          i.fas.fa-trash
        br
        .columns
          .column
            span(v-html="getDataResponsiva(responsiva)")
        .columns
          .column.is-6
            a.button.is-rounded(:class="responsiva.firma_gerente === ''? '' : 'is-success'" @click="firmar(responsiva, 'E')")
              | Firmar Entrega
          .column.is-6
            a.button.is-rounded(:class="responsiva.firma_user === ''? '' : 'is-success'" @click="firmar(responsiva, 'R')")
              | Firmar Recibe
        .columns(v-show="!verUsuarios")
          .column
            span.tag.is-light
              | Entrega: {{ responsiva.entrega }}
            | &nbsp
            a.button.is-black.is-rounded.is-small(v-show="permisos.inventarios!=6" @click="verUsuarios=true")
              span.icon
                i.fas.fa-sync
          .column
            span.tag.is-light
              | Recibe: {{ responsiva.usuario }}
        .columns(v-show="verUsuarios")
          .column.is-7
            TypeaheadUsuario(:options="usuarios" :optionSelect="usuarioSel" v-model="usuarioSel")
          .column.is-5
            a.button.is-primary.is-small(@click="cambiarEntrega")
              | Cambiar Usuario Entrega
            | &nbsp
            a.button.is-light.is-small(@click="verUsuarios=false")
              span.icon
                i.fas.fa-times
        .columns
          .column.is-3
            a.button.is-black.is-rounded(@click="imprimirResp(responsiva)") 
              i.fas.fa-print
              | &nbsp Responsiva
          .column.is-3(v-show="responsiva.categoria == 1 || responsiva.categoria == 2 || responsiva.categoria == 5")
            a.button.is-black.is-rounded(@click="imprimirInven(responsiva)")
              i.fas.fa-print
              | &nbsp Inv. Resp.
          .column.is-3
            a.button.is-black.is-rounded(@click="imprimirReglamento(responsiva)" v-show="responsiva.categoria ==5")
              i.fas.fa-print
              | &nbsp Reglamento
        .columns
          .column.is-4
            .file(v-show="!existDocumentosFromTipo(responsiva.doctos, 4)")
              label.file-label
                input.file-input(
                type='file'
                name='docto'
                @change="uploadDocumento($event, 4)"
                :disabled="permisos.inventarios==6"
                )
                span.file-cta
                  span.file-icon
                    i.fas.fa-upload
                  span.file-label
                    | Responsiva
            div(v-show="existDocumentosFromTipo(responsiva.doctos, 4)" )
              a(:href="getRuta(responsiva.doctos, 4)" target="_blank" rel="noreferer noopener")
                div.conteiner-pdf
                  a.button.is-small.is-rounded
                    span.icon
                      i.fas.fa-file-pdf
                    | &nbspResponsiva
              a.button.is-danger.is-rounded.is-small(v-show="existDocumentosFromTipo(responsiva.doctos, 4)" @click="borrarDocumento(responsiva.doctos,4)")
                span.icon
                  i.fas.fa-trash
          .column.is-4(v-show="responsiva.categoria == 1 || responsiva.categoria == 2 || responsiva.categoria == 5")
            .file(v-show="!existDocumentosFromTipo(responsiva.doctos, 5)")
              label.file-label
                input.file-input(
                type='file'
                name='docto'
                @change="uploadDocumento($event, 5)"
                :disabled="permisos.inventarios==6"
                )
                span.file-cta
                  span.file-icon
                    i.fas.fa-upload
                  span.file-label
                    | Inv. Responsiva
            div(v-show="existDocumentosFromTipo(responsiva.doctos, 5)" )
              a(:href="getRuta(responsiva.doctos, 5)" target="_blank" rel="noreferer noopener")
                div.conteiner-pdf
                  a.button.is-small.is-rounded
                    span.icon
                      i.fas.fa-file-pdf
                    | &nbspInv. Responsiva
              a.button.is-danger.is-rounded.is-small(@click="borrarDocumento(responsiva.doctos,5)")
                span.icon
                  i.fas.fa-trash
          .column.is-4(v-show="responsiva.categoria == 5")
            .file(v-show="!existDocumentosFromTipo(responsiva.doctos, 6)")
              label.file-label
                input.file-input(
                type='file'
                name='docto'
                @change="uploadDocumento($event, 6)"
                :disabled="permisos.inventarios==6"
                )
                span.file-cta
                  span.file-icon
                    i.fas.fa-upload
                  span.file-label
                    | Reglamento
            div(v-show="existDocumentosFromTipo(responsiva.doctos, 6)" )
              a(:href="getRuta(responsiva.doctos, 6)" target="_blank" rel="noreferer noopener")
                div.conteiner-pdf
                  a.button.is-small.is-rounded
                    span.icon
                      i.fas.fa-file-pdf
                    | &nbspReglamento
              a.button.is-danger.is-rounded.is-small(@click="borrarDocumento(responsiva.doctos,6)")
                span.icon
                  i.fas.fa-trash
      button.modal-close.is-large.is-rounded(aria-label='close' @click.prevent="cerrarModal")
</template>

<script>
  import TypeaheadUsuario from "@/components/usuarios_Componentes/componentes/TypeaheadUsuario.vue"
  import { mapState } from 'vuex'
  export default {
    name: 'ModalResponsiva',
    components: {
      TypeaheadUsuario,
    },
    props: {
      responsiva: {
        type: Object,
        default: () => {}
      },
      verBotones: {
        type: Boolean,
        default: true
      },
      usuarios: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tipoDocto: null,
        verUsuarios: false,
        usuarioSel: {},
      }
    },
    methods: {
      getTipoResp( resp ) {
        let htmlRes = ''
        switch (resp.categoria) {
          case 0:
            htmlRes = `<i class="fas fa-shapes"></i> ${resp.nombre_responsiva}  `
            break
          case 1:
            htmlRes = `<i class="fas fa-laptop"></i> ${resp.nombre_responsiva}  `
            break
          case 2:
            htmlRes = `<i class="fas fa-mobile-alt"></i> ${resp.nombre_responsiva}  `
            break
          case 3:
            htmlRes = `<i class="fas fa-gas-pump"></i> ${resp.nombre_responsiva}  `
            break
          case 4:
            htmlRes = `<i class="fas fa-ticket-alt"></i> ${resp.nombre_responsiva}  `
            break
          case 5:
            htmlRes = `<i class="fas fa-car"></i> ${resp.nombre_responsiva}  `
            break
          default:
            htmlRes = `  `
            break
        }
        return htmlRes
      },

      cerrarModal() {
        this.$emit('padre:close', 'close')
      },

      firmar (responsiva, firma) {
        if (this.permisos.responsivas == 3) {
          return
        }
        responsiva['firma'] = firma
        this.$store.commit('firmarResponsiva', responsiva)
        this.$router.push('/Responsivas/Firma')
      },

      imprimirResp (responsiva) {
        let link = ''
        const currentUrl = window.location.hostname

        switch (responsiva.categoria) {
          case 0:
            link = `https://${currentUrl}/servidores/reportes/responsivas/responsiva_Multiple.php?id=${responsiva.id}&nombre=${responsiva.nombre_responsiva}`
            break
          case 1:
            link = `https://${currentUrl}/servidores/reportes/responsivas/responsiva_Computo.php?id=${responsiva.id}&nombre=${responsiva.nombre_responsiva}`
            break
          case 2:
            link = `https://${currentUrl}/servidores/reportes/responsivas/responsiva_Comunicacion.php?id=${responsiva.id}&nombre=${responsiva.nombre_responsiva}`
            break
          case 3:
            link = `https://${currentUrl}/servidores/reportes/responsivas/responsiva_Combustible.php?id=${responsiva.id}&nombre=${responsiva.nombre_responsiva}`
            break
          case 4:
            link = `https://${currentUrl}/servidores/reportes/responsivas/responsiva_Peaje.php?id=${responsiva.id}&nombre=${responsiva.nombre_responsiva}`
            break
          case 5:
            link = `https://${currentUrl}/servidores/reportes/responsivas/responsiva_Vehiculo.php?id=${responsiva.id}&nombre=${responsiva.nombre_responsiva}`
            break
          default:
            break
        }
        window.open(link, '_blank')
      },

      imprimirInven (responsiva) {
        let link = ''
        var currentUrl = window.location.hostname

        switch (parseInt(responsiva.categoria)) {
          case 1:
            link = `https://${currentUrl}/servidores/reportes/responsivas/responsiva_Inv_Computo.php?id=${responsiva.id}&nombre=${responsiva.nombre_responsiva}`
            break
          case 2:
            link = `https://${currentUrl}/servidores/reportes/responsivas/responsiva_Inv_Telefono.php?id=${responsiva.id}&nombre=${responsiva.nombre_responsiva}`
            break
          case 3:
            console.log('No hay Inventario')
            break
          case 4:
            console.log('No hay Inventario')
            break
          case 5:
            console.log(this.responsiva.items)
            const especial = this.responsiva.items[0].especial
            link = `https://${currentUrl}/servidores/reportes/responsivas/responsiva_Inv_Vehiculo.php?id=${responsiva.id}&nombre=${responsiva.nombre_responsiva}&e=${especial}`
            break
          default:
            break
        }
        window.open(link, '_blank')
      },

      imprimirReglamento(responsiva) {
        var currentUrl = window.location.hostname
        const nombre = responsiva.nombre_responsiva.trim()
        const link = `https://${currentUrl}/servidores/reportes/responsivas/reglamento_vehiculos.php?id=${responsiva.id}&nombre=${nombre}`
        window.open(link, '_blank')
      },

      getDataResponsiva (resp) {
        let htmlRes = '' 
        switch (resp.categoria) {
          case 0:
            let htmlItems = ''
            resp.items.map( i => {
              htmlItems += `<span class='tag'>${i.descripcion}</span>`
            })

            htmlRes = `
            <br />
            <p>Equipos asignados:</p>
            <br />
            <div class="field is-grouped is-grouped-multiline">
              <div class="tags">
                ${htmlItems}
              </div>
            </div>
            `
            break
          case 1:
            htmlRes = `
            <br />
            <p>Equipo asignado:</p>
            <br />
            <div class="tags has-addons">
              <span class='tag is-dark'>Equipo</span>
              <span class='tag'>${resp.items[0].descripcion}</span>
            </div>
            `
            break
          case 2:
            let telefono = `${resp.items[0].marca} - ${resp.items[0].modelo}`
            htmlRes = `
            <br />
            <p>Teléfono asignado:</p>
            <br />
            <div class="tags has-addons">
              <span class='tag is-dark'>Teléfono</span>
              <span class='tag is-light'>${telefono}</span>
            </div>
            `
            break
          case 3:
            htmlRes = `
            <br />
            <p>Tarjeta asignada:</p>
            <br />
            <div class="tags has-addons">
              <span class='tag is-dark'>Tarjeta</span>
              <span class='tag is-light'>${resp.items[0].tarjeta}</span>
            </div>
            `
            break
          case 4:
            htmlRes = `
            <br />
            <p>Dispositivo asignado:</p>
            <br />
            <div class="tags has-addons">
              <span class='tag is-dark'>Dispositivo</span>
              <span class='tag is-light'>${resp.items[0].dispositivo}</span>
              <span class='tag'>${resp.items[0].estatus}</span>
            </div>
            `
            break
          case 5:
            let descripcionAuto = `${resp.items[0].marca} - ${resp.items[0].modelo} - ${resp.items[0].anio_modelo}`
            htmlRes = `
            <br />
            <p>Vehículo asignado:</p>
            <br />
            <div class="field is-grouped is-grouped-multiline">
              <div class="control">
                <div class="tags has-addons">
                <span class='tag is-dark'>Tipo</span>
                <span class='tag is-light'>${resp.items[0].categoria}</span>
              </div>
              </div>
              <div class="control">
                <div class="tags has-addons">
                  <span class='tag is-dark'>Descripción</span>
                  <span class='tag is-light'>${descripcionAuto}</span>
                </div>
              </div>
            </div>
            
            `
            break
          default:
            htmlRes = ''
            break
        }
        return htmlRes
      },
      
      editarResponsiva (resp) {
        if (this.permisos.responsivas == 3) {
          return
        }
        this.$store.commit('editarResponsiva', resp)
        this.$router.push('/Responsivas/Editar')
      },

      borrarResponsiva (resp) {
        if (this.permisos.responsivas == 3) {
          return
        }
        this.$emit('borrarResponsiva', resp)
      },

      uploadDocumento (e, tipo) {
        if (this.permisos.responsivas == 3) {
          return
        }
        const myObjt = {
          files: e.target.files,
          tipo: tipo
        }
        this.$emit('subirDocumentoFromResponsiva', myObjt)

      },
      existDocumentosFromTipo(doctos, tipo) {
        if (doctos) {
          const isFiles = doctos.some( d => d.tipo == tipo)
          console.log(isFiles)
          return isFiles
        } else {
          return false
        }
      },

      getRuta (doctos, tipo) {
        if (doctos) {
          const isFiles = doctos.some( d => d.tipo == tipo)
          if (isFiles) {
            const documento = doctos.find( docto => docto.tipo == tipo)
            return documento.ruta
          } else {
            return '#'
          }
        } else {
          return false
        }
      },

      borrarDocumento (doctos, tipo) {
        if (this.permisos.responsivas == 3) {
          return
        }
        if (doctos) {
          const isFiles = doctos.some( d => d.tipo == tipo)
          if (isFiles) {
            const documento = doctos.find( docto => docto.tipo == tipo)
            console.log(documento)
            this.$emit('borrarDocumento', documento)
          } else {
            return '#'
          }
        } else {
          return false
        }
      },

      cambiarEntrega() {
        if (Object.keys(this.usuarioSel).length > 0) {
          this.$emit('cambiarEntrega', this.usuarioSel)
          this.verUsuarios = false
          this.usuarioSel = {}
        }
      },
    }, 
    computed: {
    ...mapState(['permisos'])
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/responsivas_Componentes/components/ModalResponsiva.vue